const getDomain = () => {
  return (
    process.env.REACT_APP_API_URL ||
    // 'http://localhost:7071'
    // 'https://1bt-dev-book-road-fc-app.azurewebsites.net'
    // 'https://uat-book-road-christadelphians.azurewebsites.net'
    // 'https://1bt-qa-book-road-fc-app.azurewebsites.net'
    'https://prod-book-road-christadelphians.azurewebsites.net'
  );
};

const configs = {
  api: {
    domains: {
      main: getDomain()
    },
    prefix: '/api',
    apiVersions: {
      version_one: '/v1'
    },
    serviceType: {
      user: '/user-service',
      media: '/media-service',
      events: '/event-service',
      webcast: '/webcast-service'
    }
  }
};

export default configs;
